import { useContext } from "react";

import UserPreferencesContext from "src/contexts/preferences/UserPreferencesContext";

/**
 * Returns preferences and update controls from the nearest preferences context.
 *
 * Postconditions: Uses the context defaults when no provider is present; persistence belongs to
 * the provider.
 */
const useUserPreferences = () => useContext(UserPreferencesContext);

export default useUserPreferences;
